import React from 'react';

import s417 from '../files/417.pdf'
import s482 from '../files/482.pdf'
import s888B from '../files/888B.pdf'

function Teaching() {
    
    return (
            <div style={teachingStyle}>
                <div style={teachingHeaderContainerStyle}>
                    <h1 style={teachingHeaderStyle}>Teaching</h1>  
                </div>
                <ul>
                    <li>
                        <p>Fall 2017 - GVPT 417: Advanced Topics in Environmental Policy Analysis - <a href={s417}>Syllabus</a></p>
                    </li>
                    <li>
                        <p>Spring 2017 - GVPT 482: Government and Politics of Latin America - <a href={s482}>Syllabus</a></p>
                    </li>
                    <li>
                        <p>Fall 2013 - GVPT 888B: Democracy and Democratization - <a href={s888B}>Syllabus</a></p>
                    </li>
                </ul>
            </div>
    )
}

const teachingStyle = {
    height: '800px',
    width: '940px',
    margin: 'auto',
    padding: '86px 10px 30px 10px',
    backgroundColor: '#fff'
}

const teachingHeaderContainerStyle = {
    margin: '30px auto'
}

const teachingHeaderStyle = {
    fontFamily: 'Lora, serif',
    fontSize: '40px',
    margin: '20px auto'
}

export default Teaching;